import React from "react";
import SidebarSubHeading from "./SidebarSubHeading";
import SidebarLabel from "./SidebarLabel";
import type { OccupationType, OccupationTypeCategories } from "~/types";
import { useSearch } from "~/context/SearchContext";

type Props = {
  occupationTypes: OccupationType[];
  occupationTypeCategories: OccupationTypeCategories;
};

const OccupationTypeSection: React.FC<Props> = ({
  occupationTypes,
  occupationTypeCategories,
}) => {
  const {
    conditions: selectedConditions,
    addCondition: handleAddCondition,
    removeCondition: handleSubCondition,
  } = useSearch();

  const getCategoryTypes = (categoryId: string) => {
    return occupationTypes.filter(
      (type) => type.occupation_type_category_id === categoryId
    );
  };

  return (
    <div className="[&>div]:my-1">
      {Object.values(occupationTypeCategories).map((category) => {
        const categoryTypes = getCategoryTypes(category.id);
        return (
          <React.Fragment key={category.key}>
            <SidebarSubHeading text={category.name} />
            <SidebarLabel
              text="全て選択"
              type="occupation_type_ids"
              value={categoryTypes.map((type) => type.id)}
            />
            {categoryTypes.map((type) => (
              <SidebarLabel
                key={type.id}
                text={type.name}
                type="occupation_type_ids"
                value={type.id}
              />
            ))}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default OccupationTypeSection;
